import {axios} from '@js/utilities/axios.js';
export default {
	namespaced: true,
	state: {},
	actions: {
		forgiveFees(context, fees) {
			return new Promise((resolve, reject) => {
				axios.post('/api/cleaner/forgive-fees', fees).then((response) => {
					resolve(response);
				}).catch((error) => {
					reject(error);
				})
			});
		},
	},
	mutations: {},
	getters: {}
}
